var storage = {
  _get: function () {
    var data = JSON.parse(window.localStorage.getItem('FormId') ?? "{}");
    return data ? data : {};
  },
  _set: function (data: any) {
    window.localStorage.setItem('FormId', JSON.stringify(data));
  },
  clear: function () {
    localStorage.removeItem('FormId');
  },
  isValid: function () {
    var uid = new Date(), result;
    try {
      window.localStorage.setItem(uid.getDate.toString(), uid.getDate.toString());
      result = window.localStorage.getItem(uid.getDate.toString()) === uid.getDate.toString();
      window.localStorage.removeItem(uid.getDate.toString());
      return result;
    } catch (e) { }
    return false;
  }
};

export const useExitTicketLocalStorage = () => {
  const getFormId = (lessonId: any) => {
    var data = storage._get()
    return data[lessonId];
  }

  const setFormId = (lessonId: any, formId: string) => {
    var data = storage._get();
    data[lessonId] = formId;
    return storage._set(data);
  }
  const removeFormId = (lessonId: any) => {
    var data = storage._get();
    delete data[lessonId];
    return storage._set(data);
  }

  return {getFormId, setFormId, removeFormId};
}
